// extracted by mini-css-extract-plugin
module.exports = {"stripeRoot":"OrderForm_stripeRoot__2MXXy","orderformProduct":"OrderForm_orderformProduct__QS54O","orderformDescription":"OrderForm_orderformDescription__22_P4"};